import { Steps } from 'antd';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { getTerminalMode } from 'utils/terminal';

const STYLES: Record<string, FlattenSimpleInterpolation> = getTerminalMode()
  ? {
      icon: css`
        min-width: 40px;
        min-height: 40px;
        font-size: 20px;
        line-height: 32px;
      `,
      title: css`
        font-size: 16px;
        line-height: 24px;
      `
    }
  : {
      icon: css`
        min-width: 24px;
        min-height: 24px;
        font-size: 12px;
        line-height: 16px;
      `,
      title: css`
        font-size: 14px;
        line-height: 20px;
      `
    };

export const AntSteps = styled(Steps)`
  &&&&& {
    .ant-steps-item {
      flex: unset;

      &:not(.ant-steps-item-disabled) .ant-steps-item-container:hover {
        [class$='-steps-item-icon'] {
          border-color: var(--v3-primary-color);
          background: unset;

          [class$='-steps-icon'] {
            color: var(--v3-primary-color);
          }
        }
        [class$='-steps-item-content'] {
          [class$='-steps-item-title'] {
            color: var(--v3-primary-color);
          }
        }
      }
      &-tail {
        display: none;
      }
      &-wait {
        [class$='-steps-item-icon'] {
          background: transparent;
          border-color: var(--v3-black-2);

          [class$='-steps-icon'] {
            color: var(--v3-text-color-secondary);
          }
        }
        [class$='-steps-item-content'] {
          [class$='-steps-item-title'] {
            color: var(--v3-text-color-secondary);
          }
        }
      }

      &-active {
        pointer-events: none;
        [class$='-steps-item-icon'] {
          background: var(--v3-black-0);
          border-color: var(--v3-primary-color);

          [class$='-steps-icon'] {
            color: var(--v3-text-color);
          }
        }
        [class$='-steps-item-content'] {
          [class$='-steps-item-title'] {
            color: var(--v3-primary-color);
          }
        }
      }

      &-finish {
        [class$='-steps-item-icon'] {
          background: var(--v3-success-color);
          border-color: var(--v3-success-color);

          [class$='-steps-icon'] {
            color: var(--v3-black-0);
          }
        }
        [class$='-steps-item-content'] {
          [class$='-steps-item-title'] {
            color: var(--v3-success-color);
          }
        }
      }
    }

    [class$='-steps-item-container'] {
      display: flex;
      flex-direction: row;
      align-items: center;

      [class$='-steps-item-icon'] {
        ${STYLES.icon};
        letter-spacing: -0.02em;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;

        [class$='-steps-icon'] {
          top: 0;
        }
      }

      [class$='-steps-item-content'] {
        [class$='-steps-item-title'] {
          ${STYLES.title};
          letter-spacing: -0.02em;
          font-weight: 500;
          white-space: nowrap;
          word-break: break-word;

          &::after {
            content: unset;
          }
        }
      }
    }
    &[class*='-steps-label-vertical'] {
      gap: 20px;

      [class$='-steps-item-container'] {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 14px;

        [class$='-steps-item-icon'] {
          margin: unset;
        }

        [class$='-steps-item-content'] {
          width: fit-content;

          [class$='-steps-item-title'] {
          }
        }
      }
    }
  }
` as typeof Steps;
